export const experienceData = [
  {
    title: "Software Developer",
    italicsTitle: "Cabitaş Software",
    tags: ["Mar 2025 - Present", "İstanbul, Türkiye", "Full-time"],
    description: (
      <>
        <div>
          <p>
            • Developed and maintained internal business applications supporting
            operational workflows
          </p>
          <p>
            • Collaborated with users and stakeholders to translate business
            requirements into technical solutions
          </p>
          <p>
            • Designed relational data models and implemented business logic for
            ERP-style systems
          </p>
          <p>
            • Built integrations between internal systems and external
            APIs and services
          </p>
          <p>
            • Automated manual operational processes and data processing
            workflows
          </p>
          <p>
            • Debugged, maintained, and improved production systems used by
            internal users
          </p>
        </div>
      </>
    ),
    imgSrc: "/images/cabitas.jpg",
    altText: "Software Developer",
  },
  {
    title: "Full-Stack Web Developer",
    italicsTitle: "Freelance",
    tags: ["Sep 2023 - Jan 2024", "Remote"],
    description: (
      <>
        <div>
          <p>
            • Developed an educational services platform for an institution
            supporting international students applying to universities in
            Türkiye
          </p>
          <p>
            • Built server-rendered public pages and an administrative dashboard
            for dynamic content management
          </p>
          <p>
            • Implemented backend functionality using Node.js, Express.js,
            MongoDB, and Pug.js
          </p>
          <p>
            • Worked directly with the client to gather requirements and deliver
            features aligned with business needs
          </p>
        </div>
      </>
    ),
    imgSrc: "/images/freelancing.png",
    altText: "Freelancing",
  },
  {
    title: "Embedded Software Engineer Intern",
    italicsTitle: "Robolabs",
    tags: ["Jun - Sep 2023", "İstanbul, Türkiye", "Full-time", "Internship"],
    description: (
      <>
        <div>
          <p>
            • Gained hands-on experience in embedded systems through engineering
            workshops and practical projects
          </p>
          <p>
            • Learned fundamentals of firmware development, microcontroller
            programming, and hardware integration
          </p>
        </div>
      </>
    ),
    imgSrc: "/images/therobolabs_logo.jpeg",
    altText: "Robolabs",
  },
];
